import React from 'react'

export const TITAN_DESIGN = { name: 'Титан', detail: 'Сатиновая проточка · болты шасси', variant: 'titan', rim: 'conic-gradient(from 20deg, #101214, #262b2e 12%, #111416 25%, #202529 44%, #363c40 52%, #101315 69%, #272d30 86%, #101214)', face: 'repeating-conic-gradient(from 0deg at 50% 50%, rgba(255,255,255,0.05) 0 0.6deg, transparent 0.6deg 1.8deg), radial-gradient(circle at 35% 25%, #20322c, #0a1110 65%, #060a09)', accent: '#9CC7B4', glow: 'rgba(160,170,175,0.16)' }
export const TITAN_LOGO_DESIGN = { ...TITAN_DESIGN, name: 'Титан · логотип', detail: 'Сатиновая проточка · знак в центре', variant: 'titan-logo' }

const CX = 120
const polarXY = (radius, deg) => [
  CX + radius * Math.cos((deg - 90) * Math.PI / 180),
  CX + radius * Math.sin((deg - 90) * Math.PI / 180)
]

const SPIN_EASING = 'cubic-bezier(0.12, 0.65, 0.60, 1)'

const Rotator = ({ rotation, spinning, returning, selected, spinDuration, elementRef, children }) => {
  const transition = !selected ? 'none' : spinning ? `transform ${spinDuration}ms ${SPIN_EASING}` : returning ? 'transform 500ms ease-out' : 'none'
  return <span ref={elementRef} className="pointer-events-none absolute inset-0" style={{ transform: `rotate(${selected ? rotation : 0}deg)`, transition }}>{children}</span>
}

const WhitePointer = ({ design }) => (
  <span className="absolute -top-1 left-1/2 h-7 w-5 -translate-x-1/2" style={{ filter: `drop-shadow(0 0 6px ${design.accent})` }}>
    <span className="block h-full w-full bg-white" style={{ clipPath: 'polygon(10% 0,90% 0,50% 100%)' }} />
  </span>
)

/* Общая конструкция обсидианового семейства: обод → лицо → сектора → риски → центр → стрелка */
const SectorBand = ({ chance }) => (
  <svg viewBox="0 0 240 240" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
    <circle cx="120" cy="120" r="101.5" fill="none" stroke={chance == null ? '#3b4245' : '#7e242c'} strokeWidth="11" />
    {chance != null && <>
      <circle cx="120" cy="120" r="101.5" fill="none" stroke="#FF4B4B" strokeWidth="11" pathLength="100" strokeDasharray={`${100 - chance} ${chance}`} strokeDashoffset={-chance} transform="rotate(-90 120 120)" />
      <circle cx="120" cy="120" r="101.5" fill="none" stroke="#00FF7F" strokeWidth="11" pathLength="100" strokeDasharray={`${chance} ${100 - chance}`} transform="rotate(-90 120 120)" />
    </>}
  </svg>
)

const ObsidianTicks = ({ chance, marks = 60 }) => (
  Array.from({ length: marks }, (_, tick) => (
    <line key={tick} x1="120" y1="18" x2="120" y2={tick % (marks / 12) === 0 ? 27 : 23} transform={`rotate(${tick * 360 / marks} 120 120)`} stroke={tick * 360 / marks < chance * 3.6 ? '#092b1d' : '#ffffff'} strokeOpacity={tick % (marks / 12) === 0 ? 0.95 : 0.8} strokeWidth={tick % (marks / 12) === 0 ? 1.5 : 0.8} />
  ))
)

const ObsidianCenter = ({ design, chance, style, logo = false, centerContent }) => (
  <span className="absolute inset-[29%] flex items-center justify-center rounded-full border border-white/15 text-center" style={{ background: design.face, boxShadow: `inset 0 2px 12px #0009, 0 0 0 4px ${design.glow}`, ...style }}>
    {logo && <img src="/images/S_logo_vector_black_white.svg" alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full invert mix-blend-screen opacity-[0.05]" />}
    {centerContent || <span className={`${logo ? 'relative z-10 ' : ''}text-[clamp(2.5rem,11vw,3.4rem)] font-black leading-none tabular-nums tracking-tight text-white`}>{chance == null ? '—' : Math.round(chance)}{chance != null && <span className="ml-0.5 text-xl" style={{ color: design.accent }}>%</span>}</span>}
  </span>
)

/* Титан — сатиновая проточка лица и болты шасси по ободу */
const TitanFace = ({ design, chance, rotation, dialRotation = 0, spinning, returning = false, selected, spinDuration = 3300, pointerRef, logo = false, centerContent }) => (
  <>
    <span className="absolute inset-0 rounded-full border border-white/25" style={{ background: design.rim }} />
    <span className="absolute inset-[9px] rounded-full border border-black/70 bg-[#0a1110]" />
    <Rotator rotation={dialRotation} spinning={spinning} returning={returning} selected={selected} spinDuration={spinDuration}>
      <SectorBand chance={chance} />
      <span className="absolute inset-[10%] rounded-full border border-black/80" style={{ background: design.face }} />
      <svg viewBox="0 0 240 240" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
        <circle cx="120" cy="120" r="100" fill="none" stroke="rgba(255,255,255,0.13)" strokeWidth=".8" />
        <circle cx="120" cy="120" r="84" fill="none" stroke="rgba(255,255,255,0.13)" strokeWidth=".8" />
        <ObsidianTicks chance={chance} />
        {!logo && <text x="120" y="193" textAnchor="middle" fontSize="6.5" letterSpacing="3.5" fill="rgba(255,255,255,0.3)" fontWeight="700">SKINOZ</text>}
      </svg>
    </Rotator>
    <svg viewBox="0 0 240 240" className="pointer-events-none absolute inset-0 h-full w-full" aria-hidden="true">
      {Array.from({ length: 10 }, (_, i) => {
        const [x, y] = polarXY(112.6, i * 36)
        return (
          <g key={i}>
            <circle cx={x} cy={y} r="4.2" fill="#101614" stroke="rgba(255,255,255,0.16)" strokeWidth=".8" />
            <line x1={x - 2.4} y1={y} x2={x + 2.4} y2={y} transform={`rotate(${i * 37} ${x} ${y})`} stroke="rgba(255,255,255,0.22)" strokeWidth="1" />
          </g>
        )
      })}
    </svg>
    <ObsidianCenter design={design} chance={chance} logo={logo} centerContent={centerContent} />
    <Rotator rotation={rotation} spinning={spinning} returning={returning} selected={selected} spinDuration={spinDuration} elementRef={pointerRef}>
      <WhitePointer design={design} />
    </Rotator>
  </>
)

const EXTRA_WHEEL_FACES = {
  titan: TitanFace,
  'titan-logo': (props) => <TitanFace {...props} logo />
}

export default function ExtraWheelFace(props) {
  const Face = EXTRA_WHEEL_FACES[props.design.variant]
  return Face ? <Face {...props} /> : null
}
